// App-level growth events: onboarding nudges and community asks.
//
// Separate from mockAnalytics/projlabAnalytics because these fire outside the
// funnels those modules track — before a visitor has set up a league at all,
// or after a draft is already over.
//
// Gating is inherited: analyticsGate.js stubs posthog.capture entirely when
// analytics is suppressed, so no host or env checks belong here.

import posthog from "posthog-js";

// Never let analytics break a nudge click — swallow capture failures.
function safeCapture(event, properties) {
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}

// Fired when a visitor with no league clicks the "Set up your league" link
// beside a DEFAULT chip. `source` says which surface converted them.
export function captureSetupNudgeClicked(source) {
  safeCapture("setup_nudge_clicked", { source: source || "unknown" });
}

// Fired when someone clicks the ask for their real auction results. Real rooms
// are the calibration bottleneck, so this is worth knowing per surface.
export function captureDataContributionClicked(source) {
  safeCapture("data_contribution_clicked", { source: source || "unknown" });
}

// Fired when a platform import is auto-saved and applied — i.e. the moment a
// stranger actually has a league, which is the step they used to fall out of.
export function captureLeagueImportSaved(platform) {
  safeCapture("league_import_saved", { platform: platform || "unknown" });
}

// The hand-built twin of the line above: fired the moment "+ Create new league"
// actually persists one. Together the two events are the whole "does this
// visitor have a league yet" funnel, which is the question setup_nudge_clicked
// opens and nothing used to close for the non-import path.
export function captureLeagueCreated(source) {
  safeCapture("league_created", { source: source || "unknown" });
}
